import { render, staticRenderFns } from "./StoreBackground.vue?vue&type=template&id=64860f4a&"
import script from "./StoreBackground.vue?vue&type=script&lang=js&"
export * from "./StoreBackground.vue?vue&type=script&lang=js&"
import style0 from "./StoreBackground.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports